module.exports = __webpack_public_path__ + "static/media/Pulse Module 2.9aebc702.jpg";